import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from '../../core/services/language.service';
import { WarningLevel } from '../enums/warning-level.enum';

@Pipe({
  name: 'warningLevelPipe',
  standalone: true,
})
export class WarningLevelPipe implements PipeTransform {
  constructor(private languageService: LanguageService) {}

  transform(warningLevel?: WarningLevel): string {
    switch (warningLevel) {
      case WarningLevel.LOW:
        return this.translate('shared.maintenance.statuses.low');
      case WarningLevel.MEDIUM:
        return this.translate('shared.maintenance.statuses.medium');
      case WarningLevel.HIGH:
        return this.translate('shared.maintenance.statuses.high');
      case WarningLevel.OVERDUE:
        return this.translate('shared.maintenance.statuses.overdue');
      default:
        return this.translate('general.unknown');
    }
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
